import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-block d-lg-none g-mobile__header" };
const _hoisted_2 = { class: "container wrapper" };
const _hoisted_3 = { class: "menu-box" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "currentColor"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M3 4h18v2H3V4zm0 7h12v2H3v-2zm0 7h18v2H3v-2z" })
], -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = { class: "search-box" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_ecommerce_box_search = _resolveComponent("g-ecommerce-box-search");
    const _component_g_navview = _resolveComponent("g-navview");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    class: "btn-nav",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.onMobileNavToogle && _ctx.onMobileNavToogle(...args))),
                    type: "button"
                }, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_g_ecommerce_box_search, { mode: "mobile" }),
                _createVNode(_component_g_navview)
            ])
        ])
    ]));
}
